import React, {useCallback, useEffect} from 'react'
import {Grid} from "@mui/material";
import {Breadcrumbs} from "../../../../Components";
import Box from "@mui/material/Box";
import {Sidebar} from "./Cards/Sidebar";
import {SecurityPanel} from "./Cards/SecurityPanel";
import {useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {fetchUser} from "../Redux/Action";

export const View = () => {

    const {id} = useParams();
    const dispatch = useDispatch();
    const [tab, setTab] = React.useState(0);

    const fetchData = useCallback(async () => {
        await fetchUser({dispatch, filters:{ id, with: ['roles', 'department'] }}).then((res) => {
            if(res.success){
            }
        })
    }, [id, dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const tabComponents = [
        <SecurityPanel />,
    ];

    return (
        <Grid container spacing={4}>

            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','USER']} />
                </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
                <Sidebar tab={tab} setTab={setTab} />
            </Grid>

            <Grid item xs={12} sm={6} md={8} lg={9}>
                {tabComponents[tab]}
            </Grid>

        </Grid>
    );
}
